import { isExist } from '@/utils'
import { observable, action, computed } from 'mobx'
import { IGoodsCategory } from '../../../goods-manage/goods-storage/goods-library/modules/edit-goods/modules/model'

class GoodSaleFilterStore {
    @observable
    scene: Array<{
        name: string
        id: number
    }> = []

    @observable
    public mergePrice: boolean = false

    @observable
    public groupName: string[] = []

    @observable
    public group: (string | number | undefined)[] = []

    @observable
    public secondGroup: (number | string)[] = []

    @observable
    public category: IGoodsCategory[] = []

    @computed
    get filterText() {
        const tip = []
        if (this.scene.length) {
            tip.push(this.scene.map(s => s.name).join('、'))
        }
        if (this.mergePrice) {
            tip.push('多售价商品合并')
        }
        if (this.groupName.length) {
            tip.push(this.groupName.join('、'))
        }
        if (this.category && this.category.length) {
            tip.push(this.category.map(c => c.name).join('、'))
        }

        return tip.join('；')
    }

    @computed
    get filterGroupText() {
        const tip = []
        if (this.scene.length) {
            tip.push(this.scene.map(s => s.name).join('、'))
        }
        if (this.groupName.length) {
            tip.push(this.groupName.join('、'))
        }

        return tip.join('；')
    }

    @computed
    get filterCategroyText() {
        const tip = []
        if (this.scene.length) {
            tip.push(this.scene.map(s => s.name).join('、'))
        }
        if (this.category && this.category.length) {
            tip.push(this.category.map(c => c.name).join('、'))
        }

        return tip.join('；')
    }

    queryFormat(q: any) {
        if (isExist(q)) {
            return q
        } else {
            return void 0
        }
    }

    @computed
    get goodNameFilterQuery() {
        return {
            sale_scene: this.queryFormat(this.scene.map(v => v.id)),
            category_list: this.queryFormat(this.category.map(c => c.id)),
            mall_group_list: this.queryFormat(
                this.group.filter(g => typeof g === 'string').map(g => +(g as string).substring(1)),
            ),
            mall_secondary_group_list: this.queryFormat(
                this.secondGroup.filter(g => typeof g === 'string').map(g => +(g as string).substring(1)),
            ),
            secondary_group_list: this.queryFormat(this.secondGroup.filter(g => typeof g === 'number')),
            group_list: this.queryFormat(this.group.filter(g => typeof g === 'number')),
            merge_pricing_method: this.mergePrice,
        }
    }

    @computed
    get goodGroupFilterQuery() {
        return {
            sale_scene: this.queryFormat(this.scene.map(v => v.id)),
            mall_group_list: this.queryFormat(
                this.group.filter(g => typeof g === 'string').map(g => +(g as string).substring(1)),
            ),
            mall_secondary_group_list: this.queryFormat(
                this.secondGroup.filter(g => typeof g === 'string').map(g => +(g as string).substring(1)),
            ),
            secondary_group_list: this.queryFormat(this.secondGroup.filter(g => typeof g === 'number')),
            group_list: this.queryFormat(this.group.filter(g => typeof g === 'number')),
        }
    }

    @computed
    get goodCategoryFilterQuery() {
        return {
            sale_scene: this.queryFormat(this.scene.map(v => v.id)),
            category_list: this.queryFormat(this.category.map(c => c.id)),
        }
    }

    @action
    public setScene(
        scene: Array<{
            name: string
            id: number
        }>,
    ) {
        this.scene = scene
    }

    @action
    public setMergePrice(merge: boolean) {
        this.mergePrice = merge
    }

    @action
    public setGroupName(name: string[]) {
        this.groupName = name
    }

    @action
    public setGroup(group: (string | number | undefined)[]) {
        this.group = group
    }

    @action
    public setSecondGroup(group: (number | string)[]) {
        this.secondGroup = group
    }

    @action
    public setCategory(cate: IGoodsCategory[]) {
        this.category = cate
    }

    @action
    public reset() {
        this.scene = []
        this.groupName = []
        this.group = []
        this.secondGroup = []
        this.mergePrice = false
        this.category = []
    }
}

export const goodSaleFilterStore = new GoodSaleFilterStore()
